const social = {
  google: 'aishaala/oauth/google/web',
  googleLoginDone: 'aishaala/oauth/google/done',
};

export {
  social,
};
